import jQuery from "jquery";
import gsap from 'gsap';

jQuery(document).ready(function ($) {


    const logotypesCarousel = function ($carouselContainer) {

        let tl1;
        let isTweenPaused = true;
        let $lgCarouselWrapper = $carouselContainer.find('.logotypes-carousel-wrapper');
        let lgCarouselWrapperWidth = $lgCarouselWrapper.width();
        let $logotypes = $carouselContainer.find('.logotype-container');
        let lgContainerWidth = $logotypes.eq(0).outerWidth(true);
        let logotypesWidth = lgContainerWidth * $logotypes.length;

        let animDuration = 8 * $logotypes.length;

        let first = $logotypes;
        let second = $carouselContainer.find('.logotype-container').clone();

        let init = function () {

            $lgCarouselWrapper.append(second);
            moveToLeft(first, second)

            checkIsInViewPort($carouselContainer);
        }

        let moveToLeft = function (_first, _second) {
            tl1 = gsap.timeline({paused: isTweenPaused})
                .set(_first, {x: 0})
                .set(_second, {x: 0})
                .to(_first, {x: logotypesWidth * -1, duration: animDuration, ease: "none",}, 0)
                .to(_second, {
                    x: logotypesWidth * -1,
                    duration: animDuration,
                    ease: "none",
                    onComplete: () => switchLogotypes(_first, _second)
                }, 0)
        }

        const switchLogotypes = function (_first, _second) {
            moveToLeft(_first, _second)
        }

        const checkIsInViewPort = function (el) {
            let $el = el;
            let elementTop = $el.offset().top;
            let elementBottom = elementTop + $el.outerHeight();
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();
            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                if (isTweenPaused) {
                    tl1?.play();
                    isTweenPaused = false;
                }
            } else {
                if (isTweenPaused === false) {
                    tl1?.pause();
                    isTweenPaused = true;
                }
            }
        }
        if (logotypesWidth > lgCarouselWrapperWidth)
            init();

        $(window).on('resize scroll', function () {
            checkIsInViewPort($carouselContainer);
        });
    }

    $('.logotypes-carousel-container').each(function () {
        logotypesCarousel($(this));
    });
});
